module.exports = __webpack_public_path__ + "static/media/foundation-for-science-and-technology-light.0a94ba4b.png";